export default __webpack_public_path__ + "static/media/hero-bg.ede4a873.jpg";